/** Progressive enhancement for the guest icon. No authentication or data storage. */
class SancturaAccountModal extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-account-open]');
    this.heading = this.querySelector('[data-account-title]');
    this.modeButton = this.querySelector('[data-account-mode]');
    if (!this.dialog || !this.trigger || !this.heading || !this.modeButton) return;
    this.styleShopButton();

    this.trigger.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof this.dialog.showModal !== 'function') return;
      try {
        this.styleShopButton();
        this.setMode(false);
        if (!this.dialog.open) this.dialog.showModal();
        event.preventDefault();
        this.heading.focus({ preventScroll: true });
      } catch {
        // Keep the real Shopify link usable if modal enhancement is unavailable.
      }
    }, options);
    this.querySelector('[data-account-close]')?.addEventListener('click', () => this.dialog.close(), options);
    this.modeButton.addEventListener('click', () => {
      this.setMode(!this.registerMode);
      this.heading.focus({ preventScroll: true });
    }, options);
    this.dialog.addEventListener('close', () => {
      this.setMode(false);
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }, options);
  }

  styleShopButton() {
    customElements.whenDefined('shop-login-button').then(() => {
      if (!this.isConnected || typeof CSSStyleSheet !== 'function' || !CSSStyleSheet.prototype.replaceSync) return;
      const root = this.querySelector('.sam-shop-native shop-login-button')?.shadowRoot;
      if (!root || !('adoptedStyleSheets' in root) || root.adoptedStyleSheets.includes(this.shopColorSheet)) return;
      // Shopify exposes no button color option. Scope the override to its branded button;
      // keep the native control, focus ring, and any authorization iframe unchanged.
      const sheet = new CSSStyleSheet();
      sheet.replaceSync('button.bg-purple-primary { background-color: #000 !important; }');
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      this.shopColorSheet = sheet;
    });
  }

  setMode(register) {
    this.registerMode = register;
    this.heading.textContent = register ? 'Create account' : 'Sign in';
    this.modeButton.textContent = register ? 'Already have an account? Sign in' : 'Create account';
  }

  disconnectedCallback() {
    this.abortController?.abort();
    if (this.dialog?.open) this.dialog.close();
  }
}

if (!customElements.get('sanctura-account-modal')) {
  customElements.define('sanctura-account-modal', SancturaAccountModal);
}
